import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar';
import EditionSelector from './Components/EditionSelector';
import PreimportDeck from './Components/Preimport';
import Footer from './Components/Footer';
import Search from './Components/Search';
import Lister from './Components/Lister';
import Deck from './Components/Deck';
import Options from './Components/Options';
import './Home.css';
import './Prehome.css';

function Crear() {
  const { search } = useLocation();
  const edition = new URLSearchParams(search).get('edition');
  const [sortBy, setSortBy] = useState('');

  if (!edition) {
    return (
      <div className="Prehome">
        <div className="navbar">
          <Navbar />
        </div>
        <div className="main-content">
          <div className="presearch">
            <EditionSelector />
          </div>
          <div className="deck">
            <PreimportDeck />
          </div>
        </div>
        <div className="footer">
          <Footer />
        </div>
      </div>
    );
  }

  return (
    <div className="Home">
      <Navbar />
      <Search sortBy={sortBy} setSortBy={setSortBy} />
      <Lister edition={edition} sortBy={sortBy} />
      <Deck />
      <Options />
    </div>
  );
}

export default Crear;
